<div class="d-flex">
  <div class="card w-100 form-right">
    <div class="back">
      <h2 *ngIf="!tagsData">{{ "forms.names.addTags" | translate }}</h2>
      <h2 *ngIf="tagsData">{{ "forms.names.editTags" | translate }}</h2>
      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form">
          <form [formGroup]="form">
            <div>
              <div class="form-section">
                <div class="mb-3">
                  <label for="name" class="form-label"
                    >{{ "inputs.name" | translate }}
                    <span class="required">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    formControlName="name"
                    required
                  />
                </div>
              </div>

              <div class="form-section">
                <div class="mb-3">
                  <label for="rule_hex" class="form-label"
                    >{{ "inputs.rule_hex" | translate }}
                    <span class="required">*</span>
                  </label>
                  <div class="color-picker-wrapper">
                    <input
                      type="text"
                      class="form-control hex-value-input"
                      [value]="form.get('hex')?.value"
                      maxlength="7"
                      pattern="#([A-Fa-f0-9]{6})"
                       id="hex"
                      formControlName="hex"
                    />
                    <input
                      type="color"
                      class="form-control form-control-hex form-control-color custom-color-picker"
                      id="hex"
                      formControlName="hex"
                      required
                    />
                  </div>
                </div>
              </div>

              <!-- <div class="form-section">
                <div class="mb-3">
                  <label for="rule_entity" class="form-label"
                    >{{ "inputs.rule_entity" | translate }}
                    <span class="required">*</span>
                  </label>
                  <select
                    class="form-select"
                    id="entity"
                    formControlName="entity"
                    required
                  >
                    <option value="" disabled selected>
                      {{ "inputs.select_option" | translate }}
                    </option>
                    <option *ngFor="let entity of entities" [value]="entity">
                      {{ entity }}
                    </option>
                  </select>
                </div>
              </div> -->
            </div>
          </form>
        </div>
      </div>
      <div class="div-form"></div>
      <div class="btn-send">
        <button
          type="submit"
          class="btn btn-primary btn-primary-form"
          (click)="opt === 'new' ? onSubmit() : onSubmitOrder()"
        >
          {{ "buttons.send" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
